var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(172), __webpack_require__.e(313), __webpack_require__.e(665), __webpack_require__.e(884), __webpack_require__.e(694)]).then(() => (() => ((__webpack_require__(9894)))));
	},
	"./HomePage": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(313), __webpack_require__.e(884), __webpack_require__.e(244)]).then(() => (() => ((__webpack_require__(2244)))));
	},
	"./ProtocolSpecificTraining": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(172), __webpack_require__.e(313), __webpack_require__.e(665), __webpack_require__.e(884), __webpack_require__.e(694)]).then(() => (() => ((__webpack_require__(4726)))));
	},
	"./GenericTraining": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(172), __webpack_require__.e(313), __webpack_require__.e(665), __webpack_require__.e(884), __webpack_require__.e(694)]).then(() => (() => ((__webpack_require__(1187)))));
	},
	"./TrainingAttestationReport": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(172), __webpack_require__.e(313), __webpack_require__.e(665), __webpack_require__.e(884), __webpack_require__.e(694)]).then(() => (() => ((__webpack_require__(720)))));
	},
	"./PdfViewerPage": () => {
		return Promise.all([__webpack_require__.e(354), __webpack_require__.e(172), __webpack_require__.e(884), __webpack_require__.e(323)]).then(() => (() => ((__webpack_require__(1851)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});